import { create } from 'zustand'

import { TOAST_MS } from '../lib/alerts'

let timer = null

/**
 * The one toast of the app (design page 16). It lives outside the router so
 * a confirmation shown by a page that immediately navigates away — «پروفایل
 * ذخیره شد.» — is still there on the next screen, and it goes on its own
 * after a moment. A new toast replaces the old one; there is no queue,
 * because two sentences stacked at the bottom of a phone read as an error.
 */
export const useToastStore = create((set) => ({
  toast: null,

  show(text) {
    if (timer) clearTimeout(timer)
    set({ toast: text })
    timer = setTimeout(() => {
      timer = null
      set({ toast: null })
    }, TOAST_MS)
  },

  dismiss() {
    if (timer) {
      clearTimeout(timer)
      timer = null
    }
    set({ toast: null })
  },
}))

/** For code outside React — a service, a store — that has a sentence to say. */
export function showToast(text) {
  useToastStore.getState().show(text)
}
